import {Component, Inject, OnInit} from '@angular/core'
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog'
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms'
import {NgClass} from '@angular/common'
import {AutoCompleteModule} from 'primeng/autocomplete'
import {IUser} from '../../../shared/model/user.model'
import {InternService} from '../intern-list/intern.service'
import {SpinnerOverlayService} from '../../../Components/spinner/spinner-overlay.service'
import {CustomerService} from '../../../shared/service/customer-service';
import {ICustomerResponseList} from '../../../shared/model/customer.model';
import {RoleService} from '../../../shared/service/role-service';
import {IRoleItem} from '../../../shared/model/role.model'
import {MultiSelect} from 'primeng/multiselect';

@Component({
  selector: 'app-interno-update',
  imports: [
    MatDialogContent,
    MatDialogActions,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    AutoCompleteModule,
    MultiSelect
  ],
  templateUrl: './intern-update.html',
  styleUrl: './intern-update.css'
})
export class InternUpdate implements OnInit {
  form!: FormGroup
  filteredCustomers: ICustomerResponseList[] = []
  selectedCustomer: ICustomerResponseList | null = null
  internUser: IUser | null = null
  roleList: IRoleItem[] = []
  loadingCounter = 0;

  constructor(private spinner: SpinnerOverlayService, private fb: FormBuilder, public dialogRef: MatDialogRef<InternUpdate>, @Inject(MAT_DIALOG_DATA) public data: any, private internService: InternService, private customerService: CustomerService, private roleService: RoleService) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: [this.internUser?.user?.name ?? '', [Validators.required]],
      email: [this.internUser?.user?.email ?? '', [Validators.required, Validators.email]],
      addressNumber: [{value: this.internUser?.user?.addressNumber ?? '', disabled: true}, [Validators.required]],
      phone: [this.internUser?.user?.phone ?? '', [Validators.required, Validators.maxLength(14), Validators.minLength(10), Validators.pattern(/^\+?\d+$/)]],
      active: this.internUser?.user?.active ?? true,
      role: [
        this.internUser?.user?.roles?.map(role => {
          return this.roleList.find(roleItem => roleItem.code === role.code)
        }) ?? [],
        Validators.required
      ]
    })

    if (this.data) {
      this.findById()
    } else {
      this.findAllRoles()
    }
  }

  findById() {
    this.handleLoading(true)

    this.internService.findById(this.data.id).subscribe({
      next: (response) => {
        this.internUser = response.body ?? null
        this.patchFormUser()
        this.findAllRoles()
      },
      error: () => {
        this.handleLoading(false)
      }
    })
  }


  close(save: boolean): void {
    this.dialogRef.close(save)
  }

  get f() {
    return this.form.controls
  }

  save() {
    this.handleLoading(true)
    const formValue = this.form.value

    const payload: any = {
      id: this.internUser?.user.id,
      active: formValue.active,
      email: formValue.email,
      name: formValue.name,
      roles: formValue.role,
      addressNumber: null,
      phone: formValue.phone
    }

    if (!this.internUser?.user.id) {
      this.internService.save(payload).subscribe({
        next: (response) => {
          this.handleLoading(true)
          this.close(true)
        },
        error: () => {
          this.handleLoading(false)
        }
      })
    } else {
      this.internService.update(payload).subscribe({
        next: (response) => {
          this.handleLoading(true)
          this.close(true)
        },
        error: () => {
          this.handleLoading(false)
        }
      })
    }
  }

  patchFormUser() {
    if (!this.internUser) return;
    this.form.patchValue({
      name: this.internUser?.user?.name,
      email: this.internUser?.user?.email,
      addressNumber: this.internUser?.user?.addressNumber,
      phone: this.internUser?.user?.phone,
      active: this.internUser?.user?.active
    });
  }


  handleLoading(loading: boolean) {
    if (loading) this.spinner.show(); else this.spinner.hide()
  }

  findAllRoles() {
    this.handleLoading(true)

    this.roleService.findAll().subscribe({
      next: (responses) => {
        const excludedRoles = ["COMPRADOR", "DUEÑO"];
        this.roleList = responses.body?.role?.filter(
          role => !excludedRoles.includes(role.code)
        ) ?? []
        
        this.patchFormRoles()
        this.handleLoading(false)
      },
      error: () => {
        this.handleLoading(false)
      }
    })
  }

  patchFormRoles() {
    this.form.patchValue({
      role: this.internUser?.user?.roles?.map(role => {
        return this.roleList.find(roleItem => roleItem.code === role.code)
      }) ?? []
    });
  }
}
